<template>
  <v-alert
    v-if="conflicts.length > 0"
    type="warning"
    dense
    outlined
    class="mt-2"
  >
    <div class="text-subtitle-2 mb-1">
      同一時間帯にテーブルの重複予約があります
    </div>
    <div
      v-for="conflict in conflicts"
      :key="conflict.id"
      class="text-body-2"
    >
      {{ formatTime(conflict.startTime) }} 〜 {{ formatTime(conflict.endTime) }}
      ({{ statusLabel(conflict.status) }})
    </div>
    <div class="mt-2 d-flex gap-2">
      <v-btn
        small
        color="warning"
        @click="$emit('continue')"
      >
        続行
      </v-btn>
      <v-btn
        small
        outlined
        @click="$emit('change')"
      >
        変更
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'BookingConflictAlert',
  props: {
    conflicts: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatTime(time) {
      if (!time) return ''
      const match = time.match(/(\d{2}):(\d{2})/)

      return match ? `${match[1]}:${match[2]}` : time
    },
    statusLabel(status) {
      const labels = {
        tentative: '仮予約',
        confirmed: '確定',
        checked_in: '来店中',
        completed: '完了',
      }

      return labels[status] || status
    },
  },
}
</script>
